<template>
  <list-template :classCustom="'list-job'">
    <template #header>
      <main-header>
        <template #filterByStatus>
          <div class="leftSection">
            <div
              class="header-title wrapper-content__main font-size__large font-weight__bold"
            >
              <h3 class="font-weight__bold">
                Báo cáo tình hình xử lý văn bản của {{ deptName }}
              </h3>
            </div>
          </div>
        </template>
      </main-header>
    </template>
    <template #view>
      <div class="view">
        <list-template :classCustom="'list-docs wrapper-content__main'">
          <template #subHeader>
            <sub-header>
              <template #content>
                <el-form
                  ref="form"
                  :model="form"
                  label-position="top"
                  class="input-no__label"
                >
                  <el-row :gutter="24" class="leftSection margin-right-10">
                    <el-col
                      :span="14"
                      class="flex-row flex-left__top custom-label__input"
                    >
                      <span class="label-input width__auto"
                      >Cá nhân/Đơn vị</span
                      >
                      <div class="receiverTreeDiv select-Unit-BanHanh">
                        <bao-cao-tinh-hinh-xl-vb-receiver-select-tree
                          ref="selectReceiverTree"
                        >
                        </bao-cao-tinh-hinh-xl-vb-receiver-select-tree>
                      </div>
                    </el-col>
                    <el-col :span="10">
                      <el-row
                        :gutter="24"
                        class="leftSection margin-right-10 margin-top-5"
                      >
                        <el-col
                          :span="24"
                          class="flex-row flex-left__top custom-label__input"
                        >
                          <span class="label-input width__auto"
                          >Thời gian chuyển</span
                          >

                          <el-date-picker
                            v-model="dateRange"
                            type="daterange"
                            format="dd/MM/yyyy"
                            class="style-fullWidth input-border__bottom input-border__radius__0"
                            :picker-options="dateQuickFilterOption"
                            range-separator="_"
                            start-placeholder="_"
                            end-placeholder="_"
                            align="right"
                            :clearable="false"
                            @change="dateRangeChanged"
                            size="medium"
                          ></el-date-picker>
                        </el-col>
                      </el-row>
                      <el-row
                        :gutter="24"
                        class="leftSection margin-right-10  margin-top-5"
                      >
                        <el-col
                          :span="24"
                          class="flex-row flex-left__top custom-label__input"
                        >
                          <span class="label-input width__auto"
                          >Trạng thái xử lý</span
                          >
                          <el-select
                            v-model="form.statuses"
                            class="style-fullWidth input-none__border has-border__bottom"
                            size="medium"
                            multiple
                            clearable
                          >
                            <el-option
                              v-for="item in statusesOptions"
                              :key="item.id"
                              :label="item.label"
                              :value="item.id"
                            >
                            </el-option>
                          </el-select>
                        </el-col>
<!--                        <el-col-->
<!--                          :span="24"-->
<!--                          class="flex-row flex-left__top custom-label__input"-->
<!--                        >-->
<!--                          <span class="label-input width__auto"-->
<!--                          >Hạn xử lý </span-->
<!--                          >-->
<!--                          <el-select-->
<!--                            v-model="form.statuses1"-->
<!--                            class="style-fullWidth input-none__border has-border__bottom"-->
<!--                            size="medium"-->
<!--                            multiple-->
<!--                            clearable-->
<!--                          >-->
<!--                            <el-option-->
<!--                              v-for="item in statusesOptions1"-->
<!--                              :key="item.id"-->
<!--                              :label="item.label"-->
<!--                              :value="item.id"-->
<!--                            >-->
<!--                            </el-option>-->
<!--                          </el-select>-->
<!--                        </el-col>-->
                      </el-row>
                      <el-row
                        :gutter="24"
                        class="leftSection margin-right-10  margin-top-5"
                      >
                        <el-col
                          :span="24"
                          class="flex-row flex-left__top custom-label__input"
                        >
                          <span class="label-input width__auto"
                          >Hình thức xử lý</span
                          >
                          <el-select
                            v-model="form.processTypes"
                            class="style-fullWidth input-none__border has-border__bottom"
                            size="medium"
                            multiple
                            clearable
                          >
                            <el-option
                              v-for="item in processTypeOptions"
                              :key="item.id"
                              :label="item.label"
                              :value="item.id"
                            >
                            </el-option>
                          </el-select>
                        </el-col>
                      </el-row>
                      <el-row
                        :gutter="24"
                        class="leftSection margin-right-10  margin-top-5"
                      >
                        <el-col
                          :span="24"
                          class="flex-row custom-label__input flex__right"
                        >
                          <el-button
                            class="btnSolid__blue"
                            size="medium"
                            @click="exportReportExcel"
                          >
                            <i class="fa fa-file-excel" aria-hidden="true"></i>
                            &nbsp;Xuất Excel
                          </el-button>
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-row>
                </el-form>
              </template>
            </sub-header>
          </template>
          <!--          <template #body>-->
          <!--            <template>-->
          <!--            </template>-->
          <!--          </template>-->
        </list-template>
      </div>
    </template>
  </list-template>
</template>

<script>
import ListTemplate from "../../common/list";
import MainHeader from "../../../components/header/main-header";
import utils from "../../../services/utils";
import h from "../../../services/h";
import constants from "../../../constants";
import SubHeader from "../../../components/main/sub-header";
import dateUtils from "../../../dateUtils";
import dateFormatter from "../../../filters/dateFormatter";
import userDeptRoleViewService from "../../../services/userDeptRoleViewService";
import BaoCaoTinhHinhXlVbReceiverSelectTree from "./bao-cao-tinh-hinh-xl-vb-receiver-select-tree";

export default {
  name: "bao-cao-tinh-hinh-xu-ly-vb",
  components: {
    BaoCaoTinhHinhXlVbReceiverSelectTree,
    SubHeader,
    MainHeader,
    ListTemplate
  },

  filters: {dateFormatter},

  computed: {
    userDeptRole() {
      return this.$store.getters.userDeptRole;
    },

    userDeptRoleId() {
      return this.$route.params.userDeptRoleId;
    },

    deptId() {
      return this.$route.params.deptId;
    }
  },

  watch: {
    items() {
      this.initItems();
      this.initFilters();
      //trick để render lại tablet;
      this.rerenderFlag = false;
      this.$nextTick(() => (this.rerenderFlag = true));
    }
  },

  data() {
    return {
      form: {
        fromDate: null,
        toDate: null,
        userDeptRoleIds: null,
        deptIds: null,
        statuses: null,
        statuses1: null,
        processTypes: null
      },
      dateRange: null,
      dateQuickFilterOption: null,
      REPORT: constants.REPORT,
      deptName: null,
      userDeptRoles: [],
      processTypeOptions: [],
      statusesOptions: [],
      statusesOptions1: []
    };
  },

  created() {
    if (!this.userDeptRole) return;
    this.deptName = this.userDeptRole.deptName;
    this.initDateQuickFilterOption();
    this.loadUserDeptRoles();
    this.initOptions();
    this.initQuery();
  },

  methods: {
    initOptions() {
      this.processTypeOptions = h.collect(
        [
          constants.PROCESS_TYPE.CHUTRI,
          constants.PROCESS_TYPE.PHOIHOP,
          constants.PROCESS_TYPE.NHANDEBIET
        ],
        processType => {
          return {
            id: processType,
            label: utils.getProcessTypeLabel(processType)
          };
        }
      );

      this.statusesOptions = h.collect(
        [
          constants.INCOMING_PROCESS_STATUS.DA_XU_LY,
          constants.INCOMING_PROCESS_STATUS.CHO_XU_LY,
          constants.INCOMING_PROCESS_STATUS.DANG_XU_LY

        ],
        status => {
          return {
            id: status,
            label: utils.getDocProcessStatusLabel(status)
          };
        }
      );
      this.statusesOptions1 = h.collect(
        [
          constants.INCOMING_PROCESS_STATUS.DUNG_HAN,
          constants.INCOMING_PROCESS_STATUS.QUA_HAN,

        ],
        status => {
          return {
            id: status,
            label: utils.getDocProcessStatusLabel(status)
          };
        }
      );
    },

    loadUserDeptRoles() {
      return userDeptRoleViewService
        .findAllForBaoCaoTinhHinhXLVb()
        .then(response => (this.userDeptRoles = response.data));
    },

    initDateQuickFilterOption() {
      this.dateQuickFilterOption = {
        shortcuts: [
          utils.buildDateQuickFilterOption(
            constants.DATE_QUICK_FILTER.CODE.THIS_MONTH_2
          ),
          utils.buildDateQuickFilterOption(
            constants.DATE_QUICK_FILTER.CODE.LAST_MONTH
          ),
          utils.buildDateQuickFilterOption(
            constants.DATE_QUICK_FILTER.CODE.NAM_NAY
          )
        ]
      };
    },

    initQuery() {
      this.form.fromDate = this.$route.query.fromDate
        ? parseInt(this.$route.query.fromDate)
        : null;
      this.form.toDate = this.$route.query.toDate
        ? parseInt(this.$route.query.toDate)
        : undefined;
      let statuses = this.$route.query.statuses || [
        constants.INCOMING_PROCESS_STATUS.DA_XU_LY,
        constants.INCOMING_PROCESS_STATUS.CHO_XU_LY,
        constants.INCOMING_PROCESS_STATUS.DANG_XU_LY
      ];
      let processTypes = this.$route.query.processTypes || [
        constants.PROCESS_TYPE.CHUTRI,
        constants.PROCESS_TYPE.PHOIHOP,
        constants.PROCESS_TYPE.NHANDEBIET
      ];
      this.form.statuses = statuses
        ? h.collect(statuses, item => parseInt(item))
        : statuses;
      this.form.processTypes = processTypes
        ? h.collect(processTypes, item => parseInt(item))
        : statuses;
      this.initDateRange();
    },

    initDateRange() {
      if (this.form.fromDate && this.form.toDate) {
        this.dateRange = [
          dateUtils.toMoment(this.form.fromDate),
          dateUtils.toMoment(this.form.toDate)
        ];
      } else {
        this.dateRange = dateUtils.getDatesByQuickFilter(
          constants.DATE_QUICK_FILTER.CODE.THIS_MONTH_2
        );
        let defaultTimeRange = dateUtils.getTimesByQuickFilter(
          constants.DATE_QUICK_FILTER.CODE.THIS_MONTH_2
        );
        this.form.fromDate = defaultTimeRange[0];
        this.form.toDate = defaultTimeRange[1];
        this.storeParamsAtUrl();
      }
    },

    dateRangeChanged() {
      this.form.fromDate =
        this.dateRange && this.dateRange[0]
          ? this.dateRange[0].getTime()
          : undefined;
      this.form.toDate =
        this.dateRange && this.dateRange[1]
          ? this.dateRange[1].getTime()
          : undefined;
    },

    buildQuery() {
      return {
        fromDate: this.form.fromDate || undefined,
        toDate: this.form.toDate || undefined,
        userDeptRoleIds: this.form.userDeptRoleIds || undefined,
        deptIds: this.form.deptIds || undefined,
        statuses: this.form.statuses || undefined,
        processTypes: this.form.processTypes || undefined
      };
    },

    validate(userDeptRoleIds, deptIds) {
      return new Promise(resolve => {
        if (
          (!userDeptRoleIds || !userDeptRoleIds.length) &&
          (!deptIds || !deptIds.length)
        ) {
          this.$message({
            message: "Cá nhân/đơn vị bắt buộc nhập",
            type: "error"
          });
          return;
        }

        let diff;
        if (!this.form.fromDate || !this.form.toDate) {
          this.$message({
            message: "Khoảng thời gian (từ ngày/đến ngày) bắt buộc nhập",
            type: "error"
          });
          return;
        }
        let fromDate = dateUtils.toMoment(this.form.fromDate);
        let toDate = dateUtils.toMoment(this.form.toDate);
        diff = toDate.diff(fromDate, "day");
        if (diff < 0) {
          this.$message({
            message: "Trường Đến ngày không được nhỏ hơn trường tới ngày",
            type: "error"
          });
          return;
        }
        if (diff > 365) {
          this.$message({
            message: "Khoảng thời gian phải nhỏ hơn 1 năm",
            type: "error"
          });
          return;
        }
        resolve();
      });
    },

    storeParamsAtUrl() {
      let query = this.buildQuery();

      let routerQuery = utils.merge(this.$router.query, {
        fromDate: query.fromDate,
        toDate: query.toDate,
        statuses: query.statuses,
        processTypes: query.processTypes
      });

      this.$router.replace({
        name: this.$router.name,
        params: this.$router.params,
        query: routerQuery
      });
    },

    convertToFilterForm(deptIds, userDeptRoleIds) {
      return {
        fromDate: this.form.fromDate,
        toDate: this.form.toDate,
        deptIds: deptIds,
        userDeptRoleIds: userDeptRoleIds,
        statuses: this.form.statuses,
        processTypes: this.form.processTypes
      };
    },

    exportReportExcel() {
      let result = this.$refs.selectReceiverTree.collectCheckedReceiversData();
      let deptIds = result.toDepartmentIds;
      let userDeptRoleIds = result.toHandlerIds;

      this.validate(deptIds, userDeptRoleIds).then(() => {
        this.storeParamsAtUrl();
        let filterForm = this.convertToFilterForm(deptIds, userDeptRoleIds);
        let query = utils.merge(filterForm, {
          userDeptRoleId: this.userDeptRoleId
        });
        let baseServiceURL = constants.BASE_SERVICE_URL;
        let reportUrl = constants.REPORT.VB_DOC.URL.BAOCAOTINHHINHXLVB;
        window.open(
          `${baseServiceURL}${reportUrl}?${utils.serialize(query)}`,
          "_blank "
        );
      });
    }
  }
};
</script>

<style scoped>
.receiverTreeDiv {
  width: calc(100% - 114px);
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/report/incomingDoc/bao-cao-tinh-hinh-xu-ly-vb.vue